export const UPSERT_FINANCE_REPORT = 'UPSERT_FINANCE_REPORT'
export const UPSERT_FINANCE_REPORT_SUCCESS = 'UPSERT_FINANCE_REPORT_SUCCESS'
export const UPSERT_FINANCE_REPORT_FAIL = 'UPSERT_FINANCE_REPORT_FAIL'

export const GET_SERVICE_REPORT = 'GET_SERVICE_REPORT'
export const GET_SERVICE_REPORT_SUCCESS = 'GET_SERVICE_REPORT_SUCCESS'
export const GET_SERVICE_REPORT_FAIL = 'GET_SERVICE_REPORT_FAIL'

export const GET_FINANCE_REPORT = 'GET_FINANCE_REPORT'
export const GET_FINANCE_REPORT_SUCCESS = 'GET_FINANCE_REPORT_SUCCESS'
export const GET_FINANCE_REPORT_FAIL = 'GET_FINANCE_REPORT_FAIL'

export const GET_FINANCE_REPORT_DETAIL_LIST = 'GET_FINANCE_REPORT_DETAIL_LIST'
export const GET_FINANCE_REPORT_DETAIL_LIST_SUCCESS = 'GET_FINANCE_REPORT_DETAIL_LIST_SUCCESS'
export const GET_FINANCE_REPORT_DETAIL_LIST_FAIL = 'GET_FINANCE_REPORT_DETAIL_LIST_FAIL'


export const UPDATE_FINANCE_REPORT_DETAIL = 'UPDATE_FINANCE_REPORT_DETAIL'
export const UPDATE_FINANCE_REPORT_DETAIL_SUCCESS = 'UPDATE_FINANCE_REPORT_DETAIL_SUCCESS'
export const UPDATE_FINANCE_REPORT_DETAIL_FAIL = 'UPDATE_FINANCE_REPORT_DETAIL_FAIL'

export const RESET_FINANCE_REPORT_LST = 'RESET_FINANCE_REPORT_LST'

export const RESET_FINANCE_REPORT_FLAG = 'RESET_FINANCE_REPORT_FLAG'